import React from "react";

// Shown in place of a list built from ARCHIVED and HISTORY workflows (those
// tabs and MY TODO LIST) until they have loaded, so an empty table is never
// mistaken for "no workflows".
const WorkflowsLoading = () => (
  <div className="is-size-7 mb-3" role="status">
    <p>Loading workflows…</p>
    <progress className="progress is-small is-link is-radiusless" max="100" aria-label="Loading workflows" />
  </div>
);

export default WorkflowsLoading;
